var React = require('react');

function AdjustableHeightInline (props) {
    return React.createElement("svg",props,[React.createElement("polygon",{"points":"24.98 16.98 24.98 13.34 20.4 8.76 15.83 13.34 15.83 16.98 19.05 13.75 19.05 26.3 15.83 23.07 15.83 26.67 20.4 31.24 24.98 26.66 24.98 23.07 21.75 26.3 21.75 13.75 24.98 16.98","key":0}),React.createElement("rect",{"x":"6.29","y":"4.98","width":"28.23","height":"2.61","key":1}),React.createElement("rect",{"x":"6.29","y":"32.41","width":"28.23","height":"2.61","key":2})]);
}

AdjustableHeightInline.defaultProps = {"id":"Warstwa_1","data-name":"Warstwa 1","viewBox":"0 0 40 40","width":"32","height":"32"};

module.exports = AdjustableHeightInline;

AdjustableHeightInline.default = AdjustableHeightInline;
